module.exports = __webpack_public_path__ + "img/app-es.228ee96d.gif";